import { ReactNode } from "react";

export default function DefaultDropdownItem(props: {
  label: string;
  subLabel?: string;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
}) {
  return (
    <div className="c-dropdown-default-item">
      {props.leftIcon && props.leftIcon}
      <div className="c-dropdown-default-item-labels">
        <div>{props.label}</div>
        {props.subLabel && (
          <small className="text-muted">{props.subLabel}</small>
        )}
      </div>
      {props.rightIcon && props.rightIcon}
    </div>
  );
}
